<template>
  <Fragment>
    <div
      ref="placeholder"
      class="lazyload-placeholder"
      v-if="!isVisible"
      :style="{ height }"
    />
    <slot v-else />
  </Fragment>
</template>

<script>
export default {
  name: 'Lazyload',

  data() {
    return {
      isVisible: false,
    };
  },

  props: {
    rootMargin: {
      type: String,
      default: '0px',
    },
    threshold: {
      type: Number,
      default: 0,
    },
    height: {
      type: String,
      default: '1px',
    },
    onVisible: {
      type: Function,
      default: () => {},
    },
  },

  mounted() {
    // if intersection observer isn't supported, just short circuit
    if (!window.IntersectionObserver) {
      this.isVisible = true;
      return;
    }

    this.observer = new IntersectionObserver(this.observeCallbak, {
      rootMargin: this.rootMargin,
      threshold: this.threshold,
    });
    this.observe();
  },

  beforeDestroy() {
    this.unobserve();
  },

  methods: {
    observeCallbak(entries, observer) {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          this.isVisible = true;
          observer.unobserve(entry.target);
          this.onVisible();
        }
      });
    },

    observe() {
      this.observer.observe(this.$refs.placeholder);
    },

    unobserve() {
      if (this.$refs.placeholder && this.observer)
        this.observer.unobserve(this.$refs.placeholder);
    },
  },
};
</script>

<style lang="scss"></style>
